import { fetchWrapper } from "./fetchWrapper";
import { BaseUrl } from "./baseUrls";

export async function updateData(formValues: FormData , rwaId: string) {
  return fetchWrapper(`${BaseUrl}/updateData?rwaId=${rwaId}`, {
    method: 'PATCH',
    body: formValues,
  });
}